import { render, staticRenderFns } from "./areaSon.vue?vue&type=template&id=4889ddc2&scoped=true&"
import script from "./areaSon.vue?vue&type=script&lang=js&"
export * from "./areaSon.vue?vue&type=script&lang=js&"
import style0 from "./areaSon.vue?vue&type=style&index=0&id=4889ddc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4889ddc2",
  null
  
)

export default component.exports